import { redirect } from '@tanstack/react-router';
import { isFeatureOn, type Feature } from '../lib/features';

/**
 * `beforeLoad` for a route behind a release flag (lib/features.ts): while the flag is off, the
 * route (and every child route) sends the user to Home. The route stays registered, so typed
 * links inside the module still compile and the screen comes back by flipping the flag.
 */
export function featureGate(feature: Feature, to: '/' | '/projects' | '/financials' = '/') {
  return () => {
    if (!isFeatureOn(feature)) throw redirect({ to, replace: true });
  };
}
